import React from 'react'
import BasicTokenCard from './BasicTokenCard'
import LiquidityGeneratorTokenCard from './LiquidityGeneratorTokenCard'
import AnnuityTokenCard from './AnnuityTokenCard'
import MultiMintTokenCard from './MultiMintTokenCard'
import InstrictionsTokenCard from './InstrictionsTokenCard'

export interface CardProps {
  token: any,
  account?: string
}

const Card: React.FC<CardProps> = ({ token, account }) => {
    const { type } = token;

    if (type==="Basic") return <BasicTokenCard token={token} account={account} />;
    if (type==="LiquidityGenerator") return <LiquidityGeneratorTokenCard token={token} account={account} />;
    if (type==="Annuity") return <AnnuityTokenCard token={token} account={account} />;
    if (type==="MultiMint") return <MultiMintTokenCard token={token} account={account} />;
    if (type==="Inscriptions") return <InstrictionsTokenCard token={token} account={account} />;

    return (null);
}

export default Card
